import {getCatalogBtn} from "../helper/helpers";
import {CatalogContext} from "../catalog_context";

const removeCartText = gettext("Remove from cart");
const addCartText = gettext("Add to cart");
const subsribeFreeText = gettext("Subscribe for free");
const getFreeText = gettext("Get for free");
const removeAcctText = gettext("Remove from account");
const purchaseText = gettext("Purchased");

let addCartUrl = catalogModule.getUrl("add_cart");
let removeCartUrl = catalogModule.getUrl("remove_cart");
let removeFreeUrl = catalogModule.getUrl("remove_free");

function useToggleCart(product, props) {
    const ctxCatalog = React.useContext(CatalogContext);
    const { catalog_data } = ctxCatalog;
    const productButton = getCatalogBtn();
    const isPkgNotFree = product.type !== "free" && product.hasOwnProperty("included_in_pkg") && product.included_in_pkg !== "not_included";
    let productPurpose;
    let defaultFormText = "";
    const isProductOwned = Object.keys(catalog_data).length > 0 && catalog_data.hasOwnProperty("addons") && catalog_data.addons[product.key];

    if(isPkgNotFree){
        // In manager any free products can be removed
        if(catalog_data.app_theme === "manager"){
            if(isProductOwned){
                defaultFormText = removeAcctText;
            } else {
                defaultFormText = subsribeFreeText;
            }
        } else {
            defaultFormText = subsribeFreeText;
        }
    } else {
        if(product.type === "free"){
            if(catalog_data.app_theme === "manager"){
                if(isProductOwned){
                    defaultFormText = removeAcctText;
                } else {
                    defaultFormText = getFreeText;
                }
            } else {
                defaultFormText = getFreeText;
            }
        } else {
            defaultFormText = addCartText;
        }
    }
    if(catalog_data.app_theme === "manager"){
        if(addCartUrl.includes("group_id") && typeof createModule !== "undefined"){
            addCartUrl = addCartUrl.replace("group_id", createModule.groupId)
        }
        if(removeCartUrl.includes("group_id") && typeof createModule !== "undefined"){
            removeCartUrl = removeCartUrl.replace("group_id", createModule.groupId)
        }
        if(props.page === "create"){
            productPurpose = createModule.getPurpose();
        }
    }
    const [formData, setFormData] = React.useState({
        product: product.key,
        product_key: product.key,
        addon_key: product.key,
        purpose: productPurpose
    });
    const [isLoading, setIsLoading] = React.useState(false);
    const [formAttr, setFormAttr] = React.useState({
        text: defaultFormText,
        btn: `${productButton}`,
        form: `add_from_cart`,
        url: addCartUrl,
        status: "add"
    });
    const toggleCart = (e) => {
        let tempFormAttr = Object.assign({}, formAttr);
        setIsLoading(true);
        if(tempFormAttr.status === "add"){
            sendAjaxPostJson(
                formData,
                addCartUrl,
                function (data) {
                    $.unblockUI();
                    if (data.result === "ok") {
                        if(typeof purpose === "undefined"){
                            if(catalog_data.app_theme === "manager") {
                                if(props.page === "create"){
                                    createModule.setPurpose(data.purpose);
                                }
                            } else {
                                purpose = data.purpose;  // #93144
                            }
                        }

                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                            'event': 'add_to_cart',
                            'ecommerce': {
                                'currencyCode': 'EUR',
                                'add': {
                                    'products': [{
                                        'id': product.key,
                                        "name": product.name,
                                        "price": product.price,
                                        "category": product.type,
                                        "quantity": 1
                                    }]
                                }
                            }
                        });

                        tempFormAttr.text = removeCartText;
                        tempFormAttr.btn = `${productButton} added`;
                        tempFormAttr.form = "remove_from_cart";
                        tempFormAttr.url = removeCartUrl;
                        tempFormAttr.status = "remove";
                        setFormAttr(tempFormAttr);
                        setIsLoading(false);
                        if(typeof catalogModule !== "undefined"){
                            catalogModule.addInCart(formData.product);
                        }
                        if(catalog_data.app_theme === "manager" && props.page === "create"){
                            if(props.onAddToCart){
                                props.onAddToCart(formData.product_key);
                            }
                        }
                        if(CartUIRender){
                            CartUIRender.updateCartNum("increase");
                        }
                    } else {
                        if (data.message && data.message.length > 0) {
                            showAndScrollErrorMessage(false, $("#products-page-error-msg"), data.message, null, false);
                        } else {
                            if (data.error) {
                                showGenericMessage("Message", data.error);
                            } else {
                                showAndScrollErrorMessage(false, $("#products-page-error-msg"),
                                    gettext("Couldn't process request. Please contact support."), null, false);
                            }
                        }
                    }
                },
                false,
                function(){
                    setIsLoading(false);
                }
            );
        } else {
            sendAjaxPostJson(
                formData,
                removeCartUrl,
                function (data) {
                    $.unblockUI();
                    if (data.result === "ok") {
                        if(typeof purpose !== "undefined"){
                            purpose = data.purpose;  // refresh the purpose #93144
                        }
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                            'event': 'remove_from_cart',
                            'ecommerce': {
                                'remove': {
                                    'products': [{
                                        'id': product.key
                                    }]
                                }
                            }
                        });

                        tempFormAttr.text = defaultFormText;
                        tempFormAttr.btn = `${productButton}`;
                        tempFormAttr.form = "add_from_cart";
                        tempFormAttr.url = addCartUrl;
                        tempFormAttr.status = "add";
                        setFormAttr(tempFormAttr);
                        setIsLoading(false);
                        if(typeof catalogModule !== "undefined"){
                            catalogModule.removeInCart(formData.product);
                        }
                        if(catalog_data.app_theme === "manager" && props.page === "create"){
                            if(props.onRemoveToCart){
                                props.onRemoveToCart(formData.product_key);
                            }
                        }
                        if(CartUIRender){
                            CartUIRender.updateCartNum("decrease");
                        }
                    } else {
                        showAndScrollErrorMessage(false, $("#products-page-error-msg"),
                            gettext("Couldn't process request. Please contact support."), null, false);
                    }
                },
                false,
                function(){
                    setIsLoading(false);
                }
            );
        }
    }
    const removeFromAcct = () => {
        let tempFormAttr = Object.assign({}, formAttr);
        setIsLoading(true);
        sendAjaxPost(
            {
                addon_key: formData.addon_key
            },
            removeFreeUrl,
            function (data) {
                if (data.message_type && data.message_type === "info") {
                    if(catalog_data.app_theme === "manager"){
                        if(isPkgNotFree){
                            tempFormAttr.text = subsribeFreeText;
                        } else {
                            tempFormAttr.text = getFreeText;
                        }
                    } else {
                        tempFormAttr.text = addCartText;
                    }
                    tempFormAttr.btn = `${productButton}`;
                    tempFormAttr.form = "add_from_cart";
                    tempFormAttr.url = addCartUrl;
                    tempFormAttr.status = "add";
                    delete catalog_data.addons[formData.addon_key];
                    setFormAttr(tempFormAttr);
                    setIsLoading(false);
                } else {
                    showAndScrollErrorMessage(false, $("#products-page-error-msg"),
                            gettext(data.message_content), null, false);
                }
            },
            false,
            function(){
                setIsLoading(false);
            }
        );
    }
    React.useEffect(() => {
        let tempFormAttr = Object.assign({}, formAttr);
        if(catalog_data.app_theme === "manager"){
            
            // if(isProductOwned){
            //     console.log("product owned")
            //     console.log(isPkgFree)
            //     if(isPkgFree){
            //         console.log("product is free")
            //         tempFormAttr.text = removeAcctText;
            //         tempFormAttr.btn = `${productButton}`;
            //         tempFormAttr.form = "remove_from_account";
            //         tempFormAttr.url = removeFreeUrl;
            //         tempFormAttr.status = "remove";
            //     } else {
            //         console.log("product is not free", product.type === "free");
            //         if(product.type === "free"){
            //             tempFormAttr.text = removeAcctText;
            //             tempFormAttr.btn = `${productButton}`;
            //             tempFormAttr.form = "remove_from_account";
            //             tempFormAttr.url = removeFreeUrl;
            //             tempFormAttr.status = "remove";
            //         }
            //     }
            // } else {
            //     console.log("product not owned")
            //     if (catalogModule.isInCart(product.key)){
            //         tempFormAttr.text = removeCartText;
            //         tempFormAttr.btn = `${productButton} added`;
            //         tempFormAttr.form = "remove_from_cart";
            //         tempFormAttr.url = removeCartUrl;
            //         tempFormAttr.status = "remove";
            //     }
            // }


            if(isPkgNotFree){
                if(isProductOwned){
                    tempFormAttr.text = removeAcctText;
                    tempFormAttr.btn = `${productButton}`;
                    tempFormAttr.form = "remove_from_account";
                    tempFormAttr.url = removeFreeUrl;
                    tempFormAttr.status = "remove";
                } else {
                    if (catalogModule.isInCart(product.key)){
                        tempFormAttr.text = removeCartText;
                        tempFormAttr.btn = `${productButton} added`;
                        tempFormAttr.form = "remove_from_cart";
                        tempFormAttr.url = removeCartUrl;
                        tempFormAttr.status = "remove";
                    }
                }
            } else {
                if(isProductOwned && product.type === "free"){
                    tempFormAttr.text = removeAcctText;
                    tempFormAttr.btn = `${productButton}`;
                    tempFormAttr.form = "remove_from_account";
                    tempFormAttr.url = removeFreeUrl;
                    tempFormAttr.status = "remove";
                } else {
                    if (catalogModule.isInCart(product.key)){
                        tempFormAttr.text = removeCartText;
                        tempFormAttr.btn = `${productButton} added`;
                        tempFormAttr.form = "remove_from_cart";
                        tempFormAttr.url = removeCartUrl;
                        tempFormAttr.status = "remove";
                    }
                }
            }
            
            // if(isProductOwned && product.type === "free"){
            //     tempFormAttr.text = removeAcctText;
            //     tempFormAttr.btn = `${productButton}`;
            //     tempFormAttr.form = "remove_from_account";
            //     tempFormAttr.url = removeFreeUrl;
            //     tempFormAttr.status = "remove";
            // } else if(isProductOwned && (product.type === "subscription" || product.type === "non-consumable")){
            //     tempFormAttr.text = purchaseText;
            //     tempFormAttr.btn = `${productButton} added`;
            //     tempFormAttr.form = "pruchased_from_account";
            //     tempFormAttr.url = "";
            //     tempFormAttr.status = "purchased";
            // } else {
            //     if (catalogModule.isInCart(product.key)){
            //         tempFormAttr.text = removeCartText;
            //         tempFormAttr.btn = `${productButton} added`;
            //         tempFormAttr.form = "remove_from_cart";
            //         tempFormAttr.url = removeCartUrl;
            //         tempFormAttr.status = "remove";
            //     }
            // }
            setFormAttr(tempFormAttr);
        } else {
            if (catalogModule.isInCart(product.key)){
                tempFormAttr.text = removeCartText;
                tempFormAttr.btn = `${productButton} added`;
                tempFormAttr.form = "remove_from_cart";
                tempFormAttr.url = removeCartUrl;
                tempFormAttr.status = "remove";
                setFormAttr(tempFormAttr);
            }
        }
    }, []);
    return {formData, isLoading, formAttr, isProductOwned, toggleCart, removeFromAcct}
}

export default useToggleCart;
